<div class="container-fluid">
  <div class="row py-3">
    <div class="col">
      <h2>Users</h2>
    </div>
    @if (
      acceptedActionRoles.has(
        $safeNavigationMigration(loggedInUser.UserAccountRole?.role)!
      )
    ) {
      <div class="col-2">
        <button class="btn btn-primary" (click)="assignUsers()">
          Assign User
        </button>
      </div>
    }
  </div>
  <div class="row">
    <div class="col" style="height: 700px">
      <app-site-users-grid
        [suppliedQueryData]="suppliedGridQueryData"
        [ColumnIdToColumnActions]="ColumnIdToColumnActions"
        [reloadGridData]="reloadGridData"
        [gridName]="'SiteUsers'"
        (actionEvent)="onActionEvent($event)"
      ></app-site-users-grid>
    </div>
  </div>
</div>
